import { Link } from "react-router-dom";
import { principles, siteInfo } from "@/mocks/site";

export default function AboutTeaser() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 pb-4 md:px-6" aria-labelledby="home-about-title">
      <div className="overflow-hidden rounded-lg bg-foreground-950 px-6 py-10 md:px-10 md:py-12">
        <div className="grid gap-8 lg:grid-cols-[1fr_1.1fr] lg:gap-14">
          <div>
            <p className="text-xs font-medium tracking-[0.25em] text-accent-400">ABOUT US</p>
            <h2 id="home-about-title" className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              {siteInfo.name} 的整理原则
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">{siteInfo.intro}</p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <ul className="grid gap-5 sm:grid-cols-2">
            {principles.map((item) => (
              <li key={item.title} className="border-l-2 border-background-800 pl-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-900 text-accent-400">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <h3 className="mt-3 text-sm font-semibold text-background-50">{item.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-background-400">{item.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}